// extracted by mini-css-extract-plugin
module.exports = {"container":"WebAi_container__O3ogh","header":"WebAi_header__2ybjN","body":"WebAi_body__2EJWX","placeholder":"WebAi_placeholder__18bZU"};